import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { goBack, push } from 'react-router-redux';
import {
  generateDataExport,
  clearDataExportError,
  validateTermsChecked,
  resetPurchaseExportData,
} from '../../redux/actions';
import { actions } from '../../../Account/redux';
import { catchErrors } from '../../../Account/redux/selectors';
import componentBase from '../../../../src/lib/component-base';
import FSFlatButton from '../../../../src/components/lib/FSFlatButton';
import IconHeader from '../../../../shared/components/IconHeader/IconHeader';
import LargeGenericModal from '../../../../shared/components/LargeGenericModal/LargeGenericModal';
import creditCardIcon from '../../../../static/images/credit-card-icon.svg';
import sprocketsIcon from '../../../../static/images/data-export-icons/Sprockets-Icon.svg';
import Quote from './children/Quote/Quote';
import MethodOfPayment from './children/MethodOfPayment/MethodOfPayment';
import Payment from './children/Payment/Payment';
import DataExportsHeader from '../shared/DataExportsHeader';
import BannerAd from '../../../../shared/components/BannerAd/BannerAd';
import { DataExports as DataExportsAds } from '../ads';

const paymentOptions = ['onFile', 'newPayment'];

@connect(
  state => ({
    braintreeSubmitButtonDisabled: state.Account.braintreeSubmitButtonDisabled,
    hostedFields: state.Account.hostedFields,
    hostedFieldsDidCreate: state.Account.hostedFieldsDidCreate,
    user: state.Account.user,
    braintreeClientToken: state.Account.braintreeClientToken,
    braintreeClientTokenError: catchErrors(state.Account.braintreeClientTokenError),
    dataExportQuoteCurrentEstimate: state.DataExports.dataExportQuoteCurrentEstimate,
    createDataExport: state.DataExports.createDataExport,
    createDataExportError: state.DataExports.createDataExportError,
    createDataExportLoading: state.DataExports.createDataExportLoading,
    exportTypeKey: state.DataExports.exportTypeKey,
  }),
  actions,
)
@componentBase('PurchaseData')
export default class PurchaseData extends React.Component {
  static propTypes = {
    braintreeClientToken: PropTypes.string,
    braintreeSubmitButtonDisabled: PropTypes.bool,
    createDataExport: PropTypes.object,
    createDataExportError: PropTypes.string,
    createDataExportLoading: PropTypes.bool,
    dataExportQuoteCurrentEstimate: PropTypes.object,
    dispatch: PropTypes.func,
    endSpinner: PropTypes.func,
    getBraintreeClientToken: PropTypes.func,
    getProfile: PropTypes.func,
    history: PropTypes.object,
    hostedFields: PropTypes.object,
    hostedFieldsDidCreate: PropTypes.func,
    name: PropTypes.string,
    startSpinner: PropTypes.func,
    updateProfile: PropTypes.func,
    user: PropTypes.object.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    if (!this.onFileDisabled()) {
      this.state = {
        checked: paymentOptions[0],
        generatingReportDialogOpen: false,
      };
    } else {
      this.state = {
        checked: paymentOptions[1],
        generatingReportDialogOpen: false,
      };
    }

    this.errorDisplayWording = {
      AGREE_TERMS: 'Please read and agree to the Terms and Conditions',
      MISSING_ID: 'Please restart your search',
      SERVICE_ERROR: 'Service error, please try again later',
      UNKNOWN_ERROR: 'Error',
    };
  }

  componentDidMount() {
    const { getBraintreeClientToken, getProfile } = this.props;

    getBraintreeClientToken();
    getProfile();
  }

  componentWillReceiveProps(nextProps) {
    const {
      dispatch,
      endSpinner,
    } = this.props;

    if (nextProps.createDataExportError) {
      this.context.toast.error(this.parseError(nextProps.createDataExportError), 'Error', false, 3);
      dispatch(clearDataExportError());
      dispatch(endSpinner());
    } else if (nextProps.createDataExport) {
      this.setState({
        generatingReportDialogOpen: true,
      });
      dispatch(endSpinner());
    } else {
      dispatch(endSpinner());
    }
  }

  onFileDisabled = () => !(
    this.props.user &&
    this.props.user.paymentDetails &&
    this.props.user.paymentDetails.last4
  );

  parseError = (errorText) => {
    let error = errorText && this.errorDisplayWording[errorText];
    if (errorText && !error) {
      error = errorText;
    }
    return error;
  }

  paymentMethodChanged = (option) => {
    this.props.dispatch(clearDataExportError());
    if (this.state.checked !== option) {
      this.setState({
        checked: option,
      });
    }
  }

  submitBraintreeForm = async (newPaymentInfo) => {
    const {
      dispatch,
      endSpinner,
    } = this.props;
    try {
      // user's billing info has been saved to profile
      const paymentInfo = await newPaymentInfo.braintreeFormSubmit();
      if (paymentInfo) {
        const { nonce } = paymentInfo;
        const data = {
          paymentNonce: nonce,
          id: this.props.dataExportQuoteCurrentEstimate &&
            this.props.dataExportQuoteCurrentEstimate.id,
          checked: newPaymentInfo.checked,
        };
        dispatch(generateDataExport(data));
      }
    } catch (err) {
      this.context.toast.error(this.parseError(err.result && err.result.error) || 'Please try again.', 'Error', false, 3);
      dispatch(endSpinner());
    }
  }

  submitNewPayment = async (newPaymentInfo) => {
    // newPaymentInfo = {
    // checked: bool,
    // billingFormSubmit: func,
    // braintreeFormSubmit: func
    // }

    const {
      dispatch,
      endSpinner,
      startSpinner,
    } = this.props;
    clearDataExportError();
    dispatch(validateTermsChecked(newPaymentInfo.checked));

    if (!newPaymentInfo.checked) {
      return;
    }
    dispatch(startSpinner());

    // terms have been agreed to
    try {
      const paymentAction = await newPaymentInfo.billingFormSubmit();
      if (paymentAction) {
        this.submitBraintreeForm(newPaymentInfo);
      } // end if (paymentAction)
    } catch (error) {
      this.context.toast.error(this.parseError(error.result && error.result.error) || 'Please try again.', 'Error', false, 3);
      dispatch(endSpinner());
    }
  }

  submitSavedPayment = (data) => {
    const result = {
      ...data,
    };
    const {
      dataExportQuoteCurrentEstimate,
      dispatch,
      startSpinner,
    } = this.props;

    dispatch(startSpinner());
    dispatch(clearDataExportError());
    result.id = dataExportQuoteCurrentEstimate && dataExportQuoteCurrentEstimate.id;
    dispatch(generateDataExport(result));
  }

  cancelPurchase = () => {
    const { dispatch } = this.props;
    dispatch(clearDataExportError());
    dispatch(goBack());
  }

  successfulPurchase = () => {
    if (this.props.createDataExport) {
      const { createDataExport, dispatch } = this.props;
      const { id } = createDataExport && createDataExport.data;
      dispatch(resetPurchaseExportData(id));
    }
    this.props.dispatch(push('/data-exports/home'));
  }

  handleNewExport = () => {
    this.props.dispatch(push('/data-exports/home'));
  }

  disableButtonsWhileLoading = () => {
    const {
      createDataExportLoading,
      createDataExport,
    } = this.props;

    return !!createDataExport || !!createDataExportLoading;
  }

  renderSuccessBody = () => (
    <p style={{ color: 'black' }}>
      We are now generating your data export.
      Your credit card will be charged when the export is successfully completed.
      You will now be taken back to the Data Exports page where your export
      will become available upon completion.
      Thank you for your purchase.
    </p>
  );

  render() {
    const {
      dataExportQuoteCurrentEstimate,
      braintreeClientToken,
    } = this.props;

    const subscriptionActive = (
      this.context &&
      this.context.currentUser &&
      this.context.currentUser.subscriptionActive
    );

    const adUnits = {
      mobileAd: DataExportsAds.topMobile,
      desktopAd: DataExportsAds.top,
    };

    const bannerAd = (
      <BannerAd
        topAd
        {...adUnits}
        subscriptionActive={subscriptionActive}
        style={{ marginBottom: '-10px' }}
      />
    );

    if (dataExportQuoteCurrentEstimate) {
      const { cost = '--' } = dataExportQuoteCurrentEstimate;
      return (
        <div className='purchase-data'>
          <Helmet title='Data Exports - Purchase' />
          { bannerAd }
          <DataExportsHeader
            primaryText='Purchase Data Export'
          />
          <div className='paymentWindow'>
            <div className='header'>
              <IconHeader title='Buy Data Export' icon={creditCardIcon} />
            </div>
            <Quote price={cost} />
            <MethodOfPayment
              options={paymentOptions}
              onFileDisabled={this.onFileDisabled()}
              checked={this.state.checked}
              dispatch={this.props.dispatch}
              optionChanged={this.paymentMethodChanged}
            />
            <Payment
              braintreeSubmitButtonDisabled={this.props.braintreeSubmitButtonDisabled}
              braintreeClientToken={braintreeClientToken}
              cancelPurchase={this.cancelPurchase}
              disableButtonsWhileLoading={this.disableButtonsWhileLoading()}
              dispatch={this.props.dispatch}
              hostedFields={this.props.hostedFields}
              hostedFieldsDidCreate={this.props.hostedFieldsDidCreate}
              onFileOption={this.state.checked === paymentOptions[0]}
              submitSavedPayment={this.submitSavedPayment}
              submitNewPayment={this.submitNewPayment}
              toast={this.context.toast}
              updateProfile={this.props.updateProfile}
              user={this.props.user}
              validateTermsChecked={validateTermsChecked}
            />
          </div>
          <LargeGenericModal
            isModal
            modalOpen={this.state.generatingReportDialogOpen}
            disableButtons={false}
            title='Generating Export'
            image={sprocketsIcon}
            actionTitle='OK'
            selectAction={this.successfulPurchase}
            body={this.renderSuccessBody()}
            noSecondaryButton
          />
        </div>
      );
    }

    return (
      <div className='purchase-data'>
        <Helmet title='Data Exports - Purchase' />
        { bannerAd }
        <DataExportsHeader
          primaryText='Purchase Data Export'
        />
        <div className='noQuoteError'>
          <h3 className='noQuoteErrorTitle'>Error - Please go back or start a new search</h3>
          <FSFlatButton
            label='Data Exports Home'
            onClick={this.handleNewExport}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/PurchaseData/DataExportsPurchaseDataContainer.js